import {
    SET_SHOW_CONNECTION_INDICATOR,
    SET_WARN_ON_MOBILE_DATA,
} from './constants';

export const setShowConnectionIndicator = (show: boolean) => ({
    type: SET_SHOW_CONNECTION_INDICATOR,
    payload: {
        show,
    },
});

export const setConnectionIsCorrect = (connectionIsCorrect: boolean) => ({
    type: SET_WARN_ON_MOBILE_DATA,
    payload: {
        connectionIsCorrect,
    },
});
